import { Text, Box } from "theme-ui";

import * as styles from "./TextToolTip.styles";

export default function TextToolTip({ dangerouslySetLabel, children }) {
  if (dangerouslySetLabel) {
    return (
      <Box sx={styles.textToolTip}>
        <Text
          variant="copy3Light"
          dangerouslySetInnerHTML={{ __html: dangerouslySetLabel }}
        />
      </Box>
    );
  }
  return (
    <Box sx={styles.textToolTip}>
      <Text variant="copy3Light">{children}</Text>
    </Box>
  );
}
